module.exports = __webpack_public_path__ + "img/dot.9c8fb407.svg";